module.exports = __webpack_public_path__ + "static/media/fileIcon.af5a5e04.svg";